import { BaseApiService } from "../base/base-api.service";

import { ListSortDirection, Sort } from "../../models/api/sort";
import { ExchangeRateSTO, ExchangeRateDTO } from "../../models/exchange-rates";

export class ExchangeRatesApiService extends BaseApiService<ExchangeRateDTO, ExchangeRateSTO> {
  constructor() {
    super({
      servicePath: "/ExchangeRates",
      loadItemsPath: "/GetExchangeRates",
      saveItemsPath: "/SaveExchangeRates",
    });
    this.defaultSort = [
      {
        name: "dataSource.name",
        direction: ListSortDirection.Ascending,
      } as Sort,
      {
        name: "source.name",
        direction: ListSortDirection.Ascending,
      } as Sort,
      {
        name: "year",
        direction: ListSortDirection.Ascending,
      } as Sort,
      {
        name: "month",
        direction: ListSortDirection.Ascending,
      } as Sort,
      // {
      //   name: "date",
      //   direction: ListSortDirection.Ascending,
      // } as Sort,
      {
        name: "destination.name",
        direction: ListSortDirection.Ascending,
      } as Sort,
    ];
  }
}
